// extracted by mini-css-extract-plugin
module.exports = {"wager":"_0407fe4","plus":"_47c28af","equal":"_e2b3b84"};